import { render } from "./PopularCourses.vue?vue&type=template&id=14db2720"
import script from "./PopularCourses.vue?vue&type=script&lang=js"
export * from "./PopularCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__